// extracted by mini-css-extract-plugin
export default {"wrap":"MapToggleButton_wrap__ZAe67"};